import dayjs from 'dayjs';

const ahora = dayjs();
const hoy = ahora.format('YYYY-MM-DD') || '2026-06-16';

export const inicioSucursalData = {
    sucursal: {
        id: 1,
        nombre: 'Óptica Pablos',
        codigo: 'OP-PUE-001',
        direccion: 'Av. Puebla 534, Centro, Ciudad Obregón, Sonora',
    },
    empleado: {
        id: 1001,
        nombre: 'María González López',
        foto: '',
        puestos: ['VENDEDOR', 'RECEPCIONISTA'],
    },
    fecha: hoy,
    caja: {
        aperturada: true,
        montoInicial: 2000,
        montoActual: 4850.5,
        responsable: 'María González',
        horaApertura: '08:30',
    },
    asistenciaHoy: {
        id: 9001,
        empleadoId: 1001,
        fecha: hoy,
        horaEntrada: ahora.subtract(2, 'hour').subtract(15, 'minute').toISOString() || '',
        horaSalida: null,
        horaSalidaComida: null,
        horaRegresoComida: null,
        tipoEntrada: 'MANUAL' as const,
        tipoSalida: null,
        tipoSalidaComida: null,
        tipoRegresoComida: null,
        estado: 'PUNTUAL' as const,
        turnoId: 5,
    },
    checklistApertura: {
        id: 5501,
        tipo: 'APERTURA' as const,
        items: [
            'Encender equipos de cómputo',
            'Verificar sistema de punto de venta',
            'Revisar inventario de mostrador',
            'Encender pantallas promocionales',
            'Verificar música ambiental',
            'Revisar material de recepción',
            'Confirmar citas del día',
        ],
        itemsCompletados: ['Encender equipos de cómputo', 'Verificar sistema de punto de venta', 'Encender pantallas promocionales', 'Confirmar citas del día'],
        completado: false,
        observaciones: 'Falta revisar inventario de mostrador',
        completadoEn: undefined,
        empleadoNombre: 'María González',
        fecha: hoy,
    },
    limpieza: {
        id: 5502,
        tipo: 'LIMPIEZA' as const,
        items: [
            'Mostrador limpio',
            'Baño revisado',
            'Sala de espera ordenada',
            'Equipo óptico limpio',
            'Cristales limpios',
            'Basura sacada',
        ],
        itemsCompletados: ['Mostrador limpio', 'Sala de espera ordenada', 'Basura sacada'],
        completado: false,
        observaciones: '',
        completadoEn: undefined,
        empleadoNombre: 'María González',
        fecha: hoy,
    },
    notas: [
        {
            id: 2001,
            empleadoId: 1002,
            empleadoNombre: 'Carlos Ramírez',
            empleadoFoto: '',
            contenido: 'Chicos, recuerden que hoy a las 3pm tenemos junta de sucursal. No falten, es importante para revisar las metas del mes.',
            importante: true,
            leidoPor: [1002, 1003],
            createdAt: ahora.subtract(2 , 'hour').toISOString() || '',
        },
        {
            id: 2002,
            empleadoId: 1003,
            empleadoNombre: 'Ana Lucía Torres',
            empleadoFoto: '',
            contenido: 'Ya llegó el pedido de lentes progresivos de ZEISS. Están en recepción en la caja #3. Hay que separarlos por paciente.',
            importante: false,
            leidoPor: [1003, 1001],
            createdAt: ahora.subtract(5 , 'hour').toISOString() || '',
        },
        {
            id: 2003,
            empleadoId: 1002,
            empleadoNombre: 'Carlos Ramírez',
            empleadoFoto: '',
            contenido: 'El paciente Juan Pérez llamó para confirmar que pasa mañana a recoger sus lentes. Están en el casillero B-12.',
            importante: false,
            leidoPor: [1002],
            createdAt: ahora.subtract(1 , 'hour').toISOString() || '',
        },
        {
            id: 2004,
            empleadoId: 1004,
            empleadoNombre: 'Diego Hernández',
            empleadoFoto: '',
            contenido: 'El aire acondicionado del consultorio 2 no está funcionando bien. Ya avisé a mantenimiento.',
            importante: true,
            leidoPor: [1004],
            createdAt: ahora.subtract(30 , 'minute').toISOString() || '',
        },
        {
            id: 2005,
            empleadoId: 1005,
            empleadoNombre: 'Sofía Martínez',
            empleadoFoto: '',
            contenido: 'Hola! Alguien dejó su termo en la sala de espera. Está en recepción.',
            importante: false,
            leidoPor: [],
            createdAt: ahora.subtract(45 , 'minute').toISOString() || '',
        },
    ],
    alertas: [
        {
            id: 3001,
            title: 'Meta mensual al 67%',
            description: 'La sucursal ha alcanzado el 67% de la meta de ventas mensual. Quedan 7 días hábiles.',
            type: 'info' as const,
            icon: 'heroicons_outline:chart-bar',
            read: false,
            link: '/dashboards/finance',
            createdAt: ahora.subtract(1 , 'hour').toISOString() || '',
        },
        {
            id: 3002,
            title: 'Inventario bajo en lentes de contacto',
            description: 'Las marcas Acuvue Oasys (-2.25) y Biofinity (-1.75) están en punto de reorden. Contactar al proveedor.',
            type: 'warning' as const,
            icon: 'heroicons_outline:exclamation',
            read: false,
            link: '/inventarios/dashboard',
            createdAt: ahora.subtract(3 , 'hour').toISOString() || '',
        },
        {
            id: 3003,
            title: 'Pago de renta vence en 5 días',
            description: 'El pago de la renta del local vence el 21 de junio. Monto: $18,500 MXN.',
            type: 'error' as const,
            icon: 'heroicons_outline:currency-dollar',
            read: true,
            link: '/contabilidad/dashboard',
            createdAt: ahora.subtract(1 , 'day').toISOString() || '',
        },
        {
            id: 3004,
            title: 'Nuevo convenio: Seguros AXA',
            description: 'Se ha activado el convenio con Seguros AXA. Descuento del 20% en armazones para asegurados.',
            type: 'success' as const,
            icon: 'heroicons_outline:check-circle',
            read: false,
            createdAt: ahora.subtract(2 , 'day').toISOString() || '',
        },
    ],
    lentesParaEntregar: [
        {
            id: 4001,
            folio: 'VTA-2026-0891',
            paciente: { nombre: 'Roberto Sánchez Ruiz', telefono: '6441234567' },
            productos: [{ modelo: 'PureAir 2', marca: 'Essilor' }],
            fechaEntregaEstimada: '2026-06-18',
            diasEnTienda: 4,
            prioridad: 'ALTA' as const,
        },
        {
            id: 4002,
            folio: 'VTA-2026-0903',
            paciente: { nombre: 'Laura Gómez Mendoza', telefono: '6442345678' },
            productos: [{ modelo: 'Ray-Ban RX 7047', marca: 'Ray-Ban' }],
            fechaEntregaEstimada: '2026-06-20',
            diasEnTienda: 2,
            prioridad: 'MEDIA' as const,
        },
        {
            id: 4003,
            folio: 'VTA-2026-0875',
            paciente: { nombre: 'Fernando Díaz Herrera', telefono: '6443456789' },
            productos: [{ modelo: 'Zeiss DuraVision', marca: 'Zeiss' }],
            fechaEntregaEstimada: '2026-06-10',
            diasEnTienda: 10,
            prioridad: 'ALTA' as const,
        },
        {
            id: 4004,
            folio: 'VTA-2026-0910',
            paciente: { nombre: 'Patricia López Vega', telefono: '6444567890' },
            productos: [{ modelo: 'Crizal Sapphire', marca: 'Essilor' }],
            fechaEntregaEstimada: '2026-06-17',
            diasEnTienda: 1,
            prioridad: 'BAJA' as const,
        },
        {
            id: 4005,
            folio: 'VTA-2026-0888',
            paciente: { nombre: 'Miguel Ángel Torres', telefono: '6445678901' },
            productos: [{ modelo: 'Transitions XTRActive', marca: 'Transitions' }],
            fechaEntregaEstimada: '2026-06-20',
            diasEnTienda: 3,
            prioridad: 'MEDIA' as const,
        },
    ],
    contactosPendientes: [
        {
            id: 5001,
            nombre: 'Gabriela Ríos Castillo',
            telefono: '6446789012',
            celular: '6446789012',
            ultimaVisita: '2026-05-15',
            motivoContacto: 'REVISION' as const,
            ultimaCita: '2026-05-15',
            totalCompras: 3,
        },
        {
            id: 5002,
            nombre: 'Jorge Navarro León',
            telefono: '6447890123',
            ultimaVisita: '2026-06-01',
            motivoContacto: 'ANIVERSARIO' as const,
            totalCompras: 1,
        },
        {
            id: 5003,
            nombre: 'Claudia Espinoza Ríos',
            telefono: '6448901234',
            celular: '6448901234',
            ultimaVisita: '2026-03-20',
            motivoContacto: 'RECOMPRA' as const,
            totalCompras: 5,
        },
        {
            id: 5004,
            nombre: 'Alejandro Vargas Cruz',
            telefono: '6449012345',
            ultimaVisita: '2026-05-28',
            motivoContacto: 'SEGUIMIENTO' as const,
            ultimaCita: '2026-05-28',
            totalCompras: 2,
        },
    ],
    citasDelDia: [
        {
            id: 6001,
            hora: '09:30',
            paciente: { nombre: 'Carmen Álvarez Núñez', telefono: '6443210987' },
            descripcion: 'Examen de la vista completo + ajuste de lentes progresivos',
            tipo: 'OPTOMETRÍA',
            estatus: 'COMPLETADA' as const,
        },
        {
            id: 6002,
            hora: '11:00',
            paciente: { nombre: 'Raúl Mendoza García', telefono: '6444321098' },
            descripcion: 'Primera consulta - evaluación de miopía',
            tipo: 'OPTOMETRÍA',
            estatus: 'EN_CURSO' as const,
        },
        {
            id: 6003,
            hora: '11:00',
            paciente: { nombre: 'Beatriz Salazar Ortiz', telefono: '6445432109' },
            descripcion: 'Entrega de lentes y ajuste final',
            tipo: 'ENTREGA',
            estatus: 'PROGRAMADA' as const,
        },
        {
            id: 6004,
            hora: '13:30',
            paciente: { nombre: 'Oscar Fuentes Luna', telefono: '6446543210' },
            descripcion: 'Revisión de lentes de contacto - seguimiento mensual',
            tipo: 'SEGUIMIENTO',
            estatus: 'CONFIRMADA' as const,
        },
        {
            id: 6005,
            hora: '16:00',
            paciente: { nombre: 'Diana Rangel Padilla', telefono: '6447654321' },
            descripcion: 'Consulta pediátrica - hijo de 8 años',
            tipo: 'OPTOMETRÍA',
            estatus: 'PROGRAMADA' as const,
        },
        {
            id: 6006,
            hora: '17:30',
            paciente: { nombre: 'Hugo Martínez Soto', telefono: '6448765432' },
            descripcion: 'Elección de armazón y cotización de micas',
            tipo: 'VENTA',
            estatus: 'CANCELADA' as const,
        },
    ],
    atajosRapidos: [
        { label: 'Punto de Venta', icono: 'heroicons_outline:shopping-cart', ruta: '/venta/venta/list' },
        { label: 'Agenda', icono: 'heroicons_outline:calendar', ruta: '/cita/cita/list' },
        { label: 'Clientes', icono: 'heroicons_outline:user-group', ruta: '/apps/cliente/list' },
        { label: 'Inventario', icono: 'heroicons_outline:archive', ruta: '/inventarios/dashboard' },
        { label: 'Laboratorio', icono: 'heroicons_outline:beaker', ruta: '/proveedor/laboratorio/list' },
        { label: 'Reportes', icono: 'heroicons_outline:chart-bar', ruta: '/reportes/centro' },
        { label: 'Chat', icono: 'heroicons_outline:chat-bubble-left-right', ruta: '/apps/chat' },
        { label: 'Tablero', icono: 'heroicons_outline:presentation-chart-bar', ruta: '/dashboards/finance' },
    ],
    widgetsVisibles: [
        'apertura-caja',
        'reloj-checador',
        'checklist-apertura',
        'citas-dia',
        'lentes-entregar',
        'contactos-clientes',
        'limpieza',
        'alertas',
        'notas-companeros',
        'atajos-rapidos',
    ],
    ordenWidgets: [
        'apertura-caja',
        'reloj-checador',
        'checklist-apertura',
        'citas-dia',
        'lentes-entregar',
        'contactos-clientes',
        'limpieza',
        'alertas',
        'notas-companeros',
        'atajos-rapidos',
    ],
};
